import React from 'react';

class Logo extends React.Component {
	render() {
		return(
			<>
				<div className="logo-container">
					b
				</div>
			</>
		)
	}
}

export default Logo;